export default __webpack_public_path__ + "static/404tree-d05976a7d25e3e96bfd8e4079f8c238c.svg";